<script setup lang="ts">
import Toast from "primevue/toast";
import { computed, nextTick, useTemplateRef, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { i18n } from "./i18n";
import { useToast } from "primevue/usetoast";
import ForbiddenView from "./views/ForbiddenView.vue";
import { useThemeStore } from "./stores/themeStore.ts";

const themeStore = useThemeStore()
const toast = useToast()
const route = useRoute()
const router = useRouter()
const closeToastClass = ref('sr-toast-fade-in')
const { t } = i18n.global

router.afterEach(async () => {
  await nextTick()
  const titleInfo = route.meta.title as string | null ?? 'Fobium.Trade'
  document.title = 'Spread Racer — ' + t(titleInfo)
});

const layoutComponent = computed(() => {
  return route.meta.layout;
});

const closeToasts = () => {
  closeToastClass.value = 'sr-toast-fade-out'
  window.setTimeout(() => { closeToastClass.value = 'sr-toast-fade-in'; toast.removeAllGroups() }, 100)
}

onMounted(() => {
  themeStore.apply()
})
const toasts = useTemplateRef<typeof Toast>('toasts')
// @ts-expect-error: Property "messages" actually exists lol
const isAnyMessageVisible = computed(() => (toasts?.value?.messages?.length ?? 0 > 0) as boolean)

</script>

<template>
  <!-- Уведомления -->
  <div style="z-index: 10001111;width: var(--p-toast-width);"
    class="fixed bottom-0 right-0 mr-5 sr-toast-fade-in sr-toasts-hider-container" v-show="isAnyMessageVisible">
    <div class="cursor-pointer p-toast-message p-toast-message-info p-2 text-center sr-close-toasts text-sm"
      :class="closeToastClass" @click="closeToasts">
      {{ $t('hideNotifications') }}
    </div>
  </div>
  <Toast ref="toasts" class="mb-6" position="bottom-right">
    <template #message="slotProps">
      <div class="flex flex-col items-start flex-auto">
        <div class="font-bold text-md">{{ slotProps.message.summary }}</div>
        <div class="text-sm">{{ slotProps.message.detail }}</div>
      </div>
    </template>
  </Toast>
  <ForbiddenView v-if="themeStore.forbidden"></ForbiddenView>
  <template v-else>
    <component :is="layoutComponent">
      <router-view v-slot="{ Component, route }">
        <Transition name="fade" mode="out-in">
          <component :is="Component" :key="route.fullPath" />
        </Transition>
      </router-view>
    </component>
  </template>
</template>
